import { post } from '@/utils/axios'

class NewsModel {

    /**
     * 新闻动态
     * @param type 新闻类型（0行业新闻；1公司新闻）
     * @param startPage 第几页
     * @param pageSize 一页数量
     * @returns {Promise<*>}
     */
    async getJournalismList(type = null, startPage = 1, pageSize = 20) {
        return post('/v1/Journalism/getJournalismList',{
            type, startPage, pageSize
        })
    }
    /**
     * 案例分享
     * @param type 类型(0裸眼3D显示屏;1裸眼3D)
     * @param startPage 第几页
     * @param pageSize 一页数量
     * @returns {Promise<*>}
     */
    async getCaseShare(type = null, startPage = 1, pageSize = 20) {
        return post('/v1/Journalism/getCaseShare',{
            type, startPage, pageSize
        })
    }


    /**
     *
     * @param id
     * @returns {AxiosPromise<any>}
     */
    async getDetail(id) {
        return post('/v1/Journalism/getJournalismInfo',{
            id
        })
    }

}

export default new NewsModel()
